var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('dashboardActionOne'),expression:"'dashboardActionOne'"}],staticClass:"mdi icon green-color mdi-account-arrow-right",attrs:{"title":"Check in user"},on:{"click":function($event){return _vm.setActionData(_vm.data, _vm.status)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }